import {
    BASE_URL_MAP,
    API_BASE_URL_MAP,
    API_BASE_WEB_SOKET_URL_MAP,
    VIKART_SITE_URL_MAP,
    LOCAL,
} from '../constants';

export const getBaseUrl = () => window.location.host;
export const getEnvironment = () => BASE_URL_MAP[getBaseUrl()] || LOCAL;
export const getApiBaseURL = () => API_BASE_URL_MAP[getEnvironment()];
export const getApiWebSoketBaseURL = () =>
    API_BASE_WEB_SOKET_URL_MAP[getEnvironment()];
export const getVikartSiteURL = () => VIKART_SITE_URL_MAP[getEnvironment()];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/services/environment.ts